import React, { useEffect } from 'react';
import { Modal } from 'antd';
import { useForm } from 'react-hook-form';
import Input from '../Input/Input';
import { useDispatch, useSelector } from 'react-redux';
import { createMailing } from '../../redux/actions/chat/createMailing';
import { resetCreateMailing } from '../../redux/slices/chat.slice';
import Swal from 'sweetalert2';
import Loading from '../Loading/Loading';

function NotificationModal({ formChecked, open, sendDataToParent, users }) {
  const form = useForm();
  const handleCancel = () => {
    sendDataToParent(false);
  };
  const {
    createMailing: { data: createMailingData, error: createMailingError, loading: createMailingLoading },
  } = useSelector((state) => state.chat);

  useEffect(() => {
    if (createMailingData) {
      Swal.fire({
        title: 'Соискателям отправлены уведомления',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      formChecked.setValue('userChecked', {});
      handleCancel();
      dispatch(resetCreateMailing());
    }
  }, [createMailingData]);

  const dispatch = useDispatch();
  const onSubmit = (data) => {
    dispatch(
      createMailing({
        can_reply: false,
        users,
        message: data.message,
      }),
    );
  };
  return (
    <>
      <Modal open={open} onCancel={handleCancel} footer="">
        <div className="mx-auto p-6 flex flex-col w-full gap-2">
          <div className="flex w-full justify-center items-center">
            <label htmlFor="message" className="flex text-4xl">
              Уведомить
            </label>
          </div>
          <div className="flex w-full">
            <Input
              type="textarea"
              classNameWrap={'w-full'}
              className="block text-black w-full p-2.5 rounded-lg leading-tight border border-1 border-gray-300 focus:border-button focus:outline-none disabled:bg-gray-200"
              form={form}
              name="message"
              placeholder={'Ваше сообщение'}
              rules={{
                required: true,
              }}
              disabled={false}
            />
            {/* <textarea id="message" name="message" rows="8" className="block text-black w-full p-2.5 rounded-lg leading-tight border border-1 border-gray-300 focus:border-button focus:outline-none disabled:bg-gray-200" placeholder="Ваше сообщение"></textarea> */}
          </div>
          <div className="felx w-full">
            <button type="button" className="text-center w-full border rounded py-2 px-4  text-button border-button border-1 hover:text-white bg-white hover:bg-button transition ease-in-out duration-300" onClick={form.handleSubmit(onSubmit)}>
              Отправить
            </button>
          </div>
        </div>{' '}
        {createMailingLoading && (
          <>
            <div className="fixed t-0 l-0 r-0 b-0 z-50 w-[100vw] h-[100vh]"> </div>
            <div className="absolute  w-[32px] h-[32px] right-4 bottom-[10px]  left-1/2 -translate-x-1/2 bg-white">
              <Loading />
            </div>
          </>
        )}
      </Modal>
    </>
  );
}

export default NotificationModal;
